<script>
  import { format } from 'svelte-i18n';
  import { Badge } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';
  import { NotificationsList } from '@client/components/notifications-list';

  import { activeNotifications, notifications, unreadNotifications } from '@client/stores/notifications';

  export let collapsed = false;

  $: count = $unreadNotifications?.length || 0;
  $: ariaLabel = count ? $format('label.X_NEW_NOTIFICATIONS', { values: { count } }) : undefined;
</script>

<NotificationsList {collapsed} notifications={$activeNotifications} on:viewed={notifications.viewNotifications}>
  <div class="me-2">
    <Icon name="bell" class="h5 mb-0 p-2" />
    {#if count}
      <sup
        class="text-danger position-absolute fade h4 mt-1"
        class:show={collapsed}
        aria-label={ariaLabel}
        aria-live="polite"
        role="status"
      >
        ●
      </sup>
    {/if}
  </div>
  <span class="fade" class:show={!collapsed}>{$format('label.NOTIFICATIONS')}</span>
  {#if count}
    <Badge pill color="danger" class="ms-auto fade {collapsed ? '' : 'show'}">
      {count}<span class="visually-hidden">&nbsp;{$format('label.NEW_NOTIFICATIONS').toLowerCase()}</span>
    </Badge>
  {/if}
</NotificationsList>

<style>
  sup {
    margin-left: -1rem;
  }
</style>
